import {
  faHourglassHalf,
  faCheckSquare,
  faMegaphone,
  faExclamationSquare,
  faCalendarTimes,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons'
import { MonitoringStatus } from 'enum'
import { FilterTypes } from './enums'

export const ICONS: Partial<
  Record<
    FilterTypes,
    {
      icon: IconDefinition
      color: string
    }
  >
> = {
  [FilterTypes.inProgress]: {
    icon: faHourglassHalf,
    color: '#D48806',
  },
  [FilterTypes.finished]: {
    icon: faCheckSquare,
    color: '#00B47C',
  },
  [FilterTypes.closed]: {
    icon: faCalendarTimes,
    color: '#213F68',
  },
  [FilterTypes.upcoming]: {
    icon: faMegaphone,
    color: '#213F68',
  },
  [FilterTypes.pending]: {
    icon: faExclamationSquare,
    color: '#FF5B55',
  },
}

export const COURSE_PROGRESS = {
  [FilterTypes.pending]: MonitoringStatus.Pending,
  [FilterTypes.inProgress]: MonitoringStatus.InProgress,
  [FilterTypes.finished]: MonitoringStatus.Finish,
}

export const KEYS_TITLE_TRANSLATIONS = {
  [FilterTypes.inProgress]: 'inProgress',
  [FilterTypes.pending]: 'pending',
  [FilterTypes.finished]: 'finished',
  [FilterTypes.premieres]: 'premieres',
  [FilterTypes.ranking_by_tags]: 'recommended',
  [FilterTypes.closed]: 'closed',
  [FilterTypes.upcoming]: 'upcoming',
  [FilterTypes.popular]: 'popular',
}
